import { useEffect } from 'react';

import { AppRoutes } from '@/routes';
import { useAuthStore, wireAuthClient } from '@/stores/authStore';

// Câblage axios ↔ store : doit être effectué une fois au chargement du module.
wireAuthClient();

function App(): JSX.Element {
  const hydrate = useAuthStore((s) => s.hydrate);
  const phase = useAuthStore((s) => s.phase);

  useEffect(() => {
    if (phase === 'idle') {
      void hydrate();
    }
  }, [phase, hydrate]);

  return (
    <div className="min-h-screen bg-pearl font-sans text-ink">
      <AppRoutes />
    </div>
  );
}

export default App;
